import {
  LoadingTextButton as LoadingTextButtonBase,
  type LoadingTextButtonProps as LoadingTextButtonBaseProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export interface LoadingTextButtonProps extends Omit<LoadingTextButtonBaseProps, "LinkComponent"> {}

export function LoadingTextButton(props: LoadingTextButtonProps) {
  return <LoadingTextButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
